import { Component } from '@angular/core';
import { SafeUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { FixMeLater, QRCodeElementType } from 'angularx-qrcode';
import { Visit } from '../../core/models/visit.model';
import { SpinnerService } from '../../core/services/spinner/spinner.service';
import { VisitService } from '../../core/services/visit/visit.service';

@Component({
  selector: 'app-pass-viewer-page',
  templateUrl: './pass-viewer-page.component.html',
  styleUrl: './pass-viewer-page.component.scss'
})
export class PassViewerPageComponent {

  public uid: string = '';
  public qrCodeDownloadLink: SafeUrl = "";

  public elementType: QRCodeElementType = "canvas";

  public visit?: Visit;

  constructor(
    public activatedRoute: ActivatedRoute,
    public spinnerService: SpinnerService,
    private visitService: VisitService
  ) {
    this.activatedRoute.params.subscribe(params => {
      this.uid = params['uid'];

      this.getData();
    });
  }

  public getScreenWidth(): number {

    if (typeof window !== 'undefined') {
      return window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth || 0;
    }

    return 0;

  }

  async getData() {

    this.spinnerService.loading = true;
    this.spinnerService.message = "Cargando pase...";

    this.visit = await this.visitService.get(
      this.uid
    );

    this.spinnerService.loading = false;
    this.spinnerService.message = "";

  }

  public onChangeURL(url: SafeUrl) {

    console.log("url changed", url);
    

    this.qrCodeDownloadLink = url;
  }

  saveAsImage(parent: FixMeLater) {
    let parentElement = null

    if (this.elementType === "canvas") {
      // fetches base 64 data from canvas
      parentElement = parent.qrcElement.nativeElement
        .querySelector("canvas")
        .toDataURL("image/png")
    } else if (this.elementType === "img" || this.elementType === "url") {
      // fetches base 64 data from image
      // parentElement contains the base64 encoded image src
      // you might use to store somewhere
      parentElement = parent.qrcElement.nativeElement.querySelector("img").src
    } else {
      alert("Set elementType to 'canvas', 'img' or 'url'.")
    }

    if (parentElement) {
      // converts base 64 encoded image to blobData
      let blobData = this.convertBase64ToBlob(parentElement)
      // saves as image
      const blob = new Blob([blobData], { type: "image/png" })
      const url = window.URL.createObjectURL(blob)
      const link = document.createElement("a")
      link.href = url
      // name of the file
      link.download = this.uid
      link.click()
    }
  }

  private convertBase64ToBlob(Base64Image: string) {
    // split into two parts
    const parts = Base64Image.split(";base64,")
    // hold the content type
    const imageType = parts[0].split(":")[1]
    // decode base64 string
    const decodedData = window.atob(parts[1])
    // create unit8array of size same as row data length
    const uInt8Array = new Uint8Array(decodedData.length)
    // insert all character code into uint8array
    for (let i = 0; i < decodedData.length; ++i) {
      uInt8Array[i] = decodedData.charCodeAt(i)
    }
    // return blob image after conversion
    return new Blob([uInt8Array], { type: imageType })
  }

}
